// import api from '@/api'

export const setResourceType = ({ state, commit }, type) => {
  commit('SET_RESOURCE_TYPE', type)
}

export const changePage = ({ state, commit }, page) => {
  commit('CHANGE_PAGE', page)
}

export const setPerPage = ({ state, commit }, perPage) => {
  commit('SET_PER_PAGE', perPage)
}

export const setSortField = ({ state, commit }, sortField) => {
  commit('SET_SORT_FIELD', sortField)
}

export const setSortOrder = ({ state, commit }, order) => {
  commit('SET_SORT_ORDER', order)
}

export const updateFilter = ({ state, commit }, updatedFilter) => {
  commit('UPDATE_FILTER', updatedFilter)
}

export const updateListSchemaFields = ({ state, commit }, updatedListSchemaFields) => {
  commit('UPDATE_LIST_SCHEMA_FIELDS', updatedListSchemaFields)
}

export const prefillOrga = ({ commit }, orga) => {
  commit('PREFILL_ORGA', orga)
}

export const saveView = ({ state, dispatch }, name) => {
  let visibleColumns = state.listSchema[state.resourceType].fields
    .filter(x => x.tableVisible)
    .map(x => x.field)
  const schema = state.listSchema[state.resourceType]
  let viewConfiguration = {
    name,
    className: schema.className,
    filter: {
      ...state.filter[state.resourceType]
    },
    config: {
      ...state.config[state.resourceType]
    },
    columns: visibleColumns
  }
  dispatch('user/saveView', viewConfiguration, { root: true })
}

export const switchView = ({ state, rootState, dispatch, commit }, index) => {
  let view = rootState.user.savedViews.find(x => x.id === index)
  console.log(view.className)
  commit('SET_RESOURCE_TYPE', view.className.toLowerCase())
  commit('UPDATE_FILTER', view.filter)
  commit('SET_PER_PAGE', view.config.perPage)
  commit('SET_SORT_ORDER', view.config.sortOrder)
  commit('SET_SORT_FIELD', view.config.sortField)
  commit('CHANGE_PAGE', view.config.page)
  commit('TOGGLE_COLUMNS', view.columns)
}

export const resetList = ({ commit }) => {
  commit('RESET_LIST')
}



// WEBPACK FOOTER //
// ./src/store/modules/list/actions.js